module.exports = __webpack_public_path__ + "img/icons/new/dropdown-rp-3eca19d714361a078f948c3914c4e26f.png";